import { WellnessWheelArcProps } from "../types";

export default function VitalsCategoryArc({
  arcColorFill,
}: WellnessWheelArcProps) {
  return (
    <path
      d="M138.5 27.2812C199.326 27.2812 248.636 76.4115 248.636 137.017C248.636 154.186 244.678 170.435 237.622 184.907"
      stroke={arcColorFill}
      strokeWidth="50.521"
      strokeLinecap="round"
      style={{
        strokeDasharray: 1000,
        strokeDashoffset: 1000,
        animation: "drawArc 1s ease-out 0.5s forwards",
      }}
    />
  );
}
